"use strict";
import AbstractPage from 'pages/AbstractPage';
import "vendor/owl.carousel.min";

export default class ProductPage extends AbstractPage {
    constructor() {
        super();

        this.initOwl();
        this.bind();
    }

    bind() {
        $('.product__buy-button').on('click', this.onBuyButtonClick.bind(this));
        $('.product__interior-gallery-item').on('click', this.showGalleryImage.bind(this));
    }

    initOwl() {
        $(".owl-carousel.align-center").each(function(index, el) {
            let containerHeight = $(el).height();

            $(el).find("img").each(function (index, img) {
                let w = $(img).prop('naturalWidth');
                let h = $(img).prop('naturalHeight');

                $(img).css({
                    'width': Math.round(containerHeight * w / h) + 'px',
                    'height': containerHeight + 'px'
                });
            });

            $(el).owlCarousel({
                loop: true,
                nav: true,
                items: 1,
                margin: 50,
                dots: false,
                URLhashListener: true,
                startPosition: 'URLHash'
            });
        });

        const galleryItemCount = $('.product__interior-gallery-item').length;

        $('.product__interior-gallery').owlCarousel({
            loop: true,
            nav: true,
            margin: 0,
            dots: false,
            responsive: {
                0: {
                    items: Math.min(galleryItemCount, 2),
                },
                768: {
                    items: Math.min(galleryItemCount, 4),
                }
            }
        });
    }

    onBuyButtonClick(e) {
        e.preventDefault();
        const $button = $(e.currentTarget);
        const productId = app.pageData.productId;
        let quantity = 1; //$('.product__quantity-input').val();

        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }

        BX.ajax.runComponentAction('nav:ajax.basket', 'add', {
            mode:'ajax',
            data: {
                id: productId,
                quantity,
            }
        }).then((response) => {
            $(document).trigger($.Event('custom:basketUpdate', response.data));
            this.setInBasketState();
        }).catch((response) => {
            alert(response.errors.map(item => item.message).join("\n"));
        });
    }

    setInBasketState() {
        $('.product__buy-button').text('В корзине');
    }

    showGalleryImage(e) {
        $('.modal__content').html(`<img class="modal__image" src="${$(e.currentTarget).find('img').attr('src')}"/>`);
        $('.modal').removeClass('hidden');
    }
}

$(function () { app.pageController = new ProductPage(); });
